export const RISK_CENTER_EVENTS = {
    VIEW_RISK_CENTER_PAGE: 'view_risk_center_page'
}

export const RISK_CENTER_EVENTS_PARAMS = {
    RISK_CENTER: 'risk_center'
}